<template>
  <el-table-column
    :label="label"
    class-name="invoice-type"
    :prop="prop"
    :rules="rules"
  >
    <template slot-scope="scope">
    <el-select
      v-model="scope.row.invoice_type"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="true"
      :filter-method="filter"
    >
      <el-option v-if="defaultBlank" label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <span style="float: left">{{ item.label }}</span>
        <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span> -->
      </el-option>
    </el-select>
    </template>
  </el-table-column>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '出力言語'
    },
    prop: {
      type: String,
      default: 'invoice_type'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    defaultBlank: {
      type: Boolean,
      default: true
    }
  },
  data () {
    const rules = []
    if (!this.disabled) {
      if (this.required) {
        rules.push(this.validatorRequired(this.label, 'change'))
      }
    }
    return {
      options: [],
      optionsOriginal: [],
      placeholder: '出力言語',
      rules
    }
  },
  computed: {
    InvoiceTypeColumn: {
      get () {
        return this.value
      },
      set (InvoiceTypeColumn) {
        this.$emit('change', InvoiceTypeColumn)
        this.options = this.optionsOriginal
      }
    }
  },
  async mounted () {
    const invoiceType = await this.loadCode()
    const invoiceTypeSet = invoiceType.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = invoiceTypeSet
    this.optionsOriginal = invoiceTypeSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'INVOICE_TYPE' } })
          .then((res) => {
            sessionStorage.setItem('invoiceType', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('invoiceType'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.invoice-type {
      width: 12em;
    }
  }
}
// .el-table {
//   td,
//   th {
//     &.invoice-type {
//       width: 7.5em;
//     }
//   }
// }
// .invoice-type {
//   ::v-deep .el-form-item__content {
//     width: 5em;
//   }
// }
// .el-select-dropdown__item span {
//   padding-left: 5px;
//   padding-right: 5px;
// }
</style>
